import { render, staticRenderFns } from "./InspectionReservationTable.vue?vue&type=template&id=2067aa0a&scoped=true&lang=pug"
import script from "./InspectionReservationTable.vue?vue&type=script&lang=ts"
export * from "./InspectionReservationTable.vue?vue&type=script&lang=ts"
import style0 from "./InspectionReservationTable.vue?vue&type=style&index=0&id=2067aa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067aa0a",
  null
  
)

export default component.exports